import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonComponent } from '@shared/components/button';
import {
  IconDefinition,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  LOCK_SECTION_MODAL_LOCK_MESSAGE,
  LOCK_SECTION_MODAL_UNLOCK_MESSAGE,
} from './lock-section-modal.constants';

@Component({
  selector: 'app-lock-section-modal',
  standalone: true,
  imports: [ButtonComponent, FontAwesomeModule],
  templateUrl: './lock-section-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockSectionModalComponent {
  public dialogRef = inject(DialogRef<boolean>);
  public data: { section: string; isLocking: boolean } = inject(DIALOG_DATA);

  protected readonly faTriangleExclamation: IconDefinition =
    faTriangleExclamation;

  public readonly lockMessage = LOCK_SECTION_MODAL_LOCK_MESSAGE(
    this.data.section,
  );
  public readonly unlockMessage = LOCK_SECTION_MODAL_UNLOCK_MESSAGE;

  public onCancel(): void {
    this.dialogRef.close(false);
  }

  public onConfirm(): void {
    this.dialogRef.close(true);
  }
}
